import fetchData from "../api/Fetch";

export const fetchOrganisationMembers = async (organisationID) => {
  if (!organisationID) return;

  let response = await fetchData("organisation/" + organisationID + "/members");
  return response;
};
